import { takeEvery, call, put } from 'redux-saga/effects';
import empSearchApi from 'api/employee/empSearchApi';
import * as myPinActions from 'redux/ducks/setting/myPinDucks';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getPrioritySearchLimit() {
  try {
    const response = yield call(empSearchApi.getPrioritySearchLimit);
    yield put(myPinActions.getPrioritySearchLimitSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* getPrioritySearchList({ payload }) {
  try {
    const response = yield call(empSearchApi.getPrioritySearchList, payload);
    yield put(myPinActions.getPrioritySearchListSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* removePrioritySearch({ payload }) {
  try {
    const response = yield call(empSearchApi.removePrioritySearch, payload);
    yield put(myPinActions.removePrioritySearchSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export function* addPrioritySearch({ payload }) {
  try {
    const response = yield call(empSearchApi.addPrioritySearch, payload);
    yield put(myPinActions.addPrioritySearchSuccess(response));
  } catch (error) {
    yield put(alertActions.open({ message: [error.errorCode] }));
  }
}

export default function* myPinSaga() {
  yield takeEvery(myPinActions.getPrioritySearchLimit, getPrioritySearchLimit);
  yield takeEvery(myPinActions.getPrioritySearchList, getPrioritySearchList);
  yield takeEvery(myPinActions.removePrioritySearch, removePrioritySearch);
  yield takeEvery(myPinActions.addPrioritySearch, addPrioritySearch);
}
